import { render, staticRenderFns } from "./annonces.vue?vue&type=template&id=5070e4ba&scoped=true&"
import script from "./annonces.vue?vue&type=script&lang=js&"
export * from "./annonces.vue?vue&type=script&lang=js&"
import style0 from "./annonces.vue?vue&type=style&index=0&id=5070e4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5070e4ba",
  null
  
)

export default component.exports